import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { RootState } from "../index";
import {
  fetchCsvImport,
  fetchCsvImports,
  createCsvImport
} from "../../actions/callrecorder/csvImportsActions";

export type CsvImportStatus = 'pending' | 'processing' | 'completed' | 'failed';

export interface CsvImportInterface {
  url: string;

  id: number,

  provider_id: number,
  import_type: 'rate' | 'phone_number_price',
  status: CsvImportStatus,
  is_done: boolean,
  msg: string | null,
  csv_file_url: string | null,
  total_rows: number,
  processed_rows: number,
  error_rows: number,
  progress: number,

  created_at: string,
  updated_at: string
}

export interface initialInterface {
  error: string | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  count: number;

  newParams: object | undefined;
  newError: string | null;
}

const initialState: initialInterface = {
  error: null,
  status: 'idle',
  count: 0,

  newParams: undefined,
  newError: null
};

const adaptor = createEntityAdapter<CsvImportInterface>();

const slice = createSlice({
  name: 'csvImports',
  initialState: adaptor.getInitialState(initialState),
  reducers: {
    setNewParams: (state, action) => {
      state.newParams = action.payload;
      state.newError  = initialState.newError;
    },
    setNewError: (state, action) => {
      state.newError = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      // #index
      .addCase(fetchCsvImports.pending, (state, _action) => {
        state.status = 'loading'
      })
      .addCase(fetchCsvImports.fulfilled, (state, action) => {
        state.count = action.payload.count;
        state.entities = action.payload.csvImports;
        state.ids = action.payload.ids;
        state.status = 'succeeded';
      })
      .addCase(fetchCsvImports.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Unknown Error';
      })

      // #show (used by polling — update entity in-place)
      .addCase(fetchCsvImport.fulfilled, (state, action) => {
        const record = Object.values(action.payload.csv_import)[0];
        state.entities[record.id] = record;
      })

      // #create
      .addCase(createCsvImport.fulfilled, (state, action) => {
        const record = Object.values(action.payload.csv_import)[0];
        state.entities[record.id] = record;
      })
      .addCase(createCsvImport.rejected, (state, action) => {
        const error = Array.isArray(action.payload) ? action.payload[0] : null;
        state.newError = error || action.error.message || 'Unknown Error';
      })
  }
});

const reducer = slice.reducer;
export default reducer;

export const {
  setNewParams,
  setNewError
} = slice.actions;

export const {
  selectById: selectCsvImportById,
  selectIds: selectCsvImportIds,
  selectEntities: selectCsvImportEntities,
}  = adaptor.getSelectors<RootState>(state => state.callrecorder.csvImports);
